export default "__VITE_ASSET__D$EnCre2__"